module.exports = __webpack_public_path__ + "img/ChooseCommission.03ba2d8e_03ba2d8eb9626faa5abfff94e1605de3.03ba2d8e.svg";